<script>
import { conversionTimeFormat } from "../utils/tool";
import Current from "./police/current.vue";
import History from "./police/history.vue";
export default {
  name: "data-police",
  data() {
    return {
      name: "current"
    };
  },
  components: {
    Current,
    History
  },
  methods: {
    conversionTimeFormat,
    // 切换模块
    switchModule(name) {
      this.name = name;
    }
  },
};
</script>

<template>
  <div class="dataPolice">
    <!-- 标题 -->
    <header>
      <div class="header-left-box">
        <div class="name">数据报警</div>
        <div class="switch">
          <div
            class="current"
            :class="{ active: name === 'current' }"
            @click="switchModule('current')">
            当前报警
          </div>
          <div
            class="history"
            :class="{ active: name === 'history' }"
            @click="switchModule('history')">
            历史报警
          </div>
        </div>
      </div>
      <div class="refresh">
        <img class="refresh-icon" src="../assets/refresh.png" />
        更新于 {{ conversionTimeFormat("YYYY-MM-dd hh:mm:ss") }}
      </div>
    </header>
    <Current v-show="name === 'current'" />
    <History v-show="name === 'history'" />
  </div>
</template>

<style scoped>
.dataPolice {
  position: absolute;
  width: 26.615vw;
  height: calc((100% - 80px) / 3);
  left: 20px;
  top: calc((100% - 80px) / 3 * 2 + 60px);
  background-color: rgba(0, 40, 69, 0.8);
  border-radius: 0.5vw;
}

header {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left-box {
  display: flex;
  align-items: center;
}

.name {
  font-size: 1.172vw;
  color: #ffffff;
  padding-left: 1vw;
}

.refresh {
  font-size: 0.8vw;
  color: #02bae1;
  display: flex;
  align-items: center;
  padding-right: 1vw;
}

.refresh-icon {
  width: 0.8vw;
  height: 0.8vw;
  margin-right: 0.2vw;
}

.switch {
  display: flex;
}

.current {
  box-sizing: content-box;
  margin-left: 0.4vw;
  margin-right: 0.2vw;
  color: #abafbb;
  font-size: 0.6vw;
  border: 0.1vw solid #0c3a54;
  height: 1vw;
  width: 3vw;
  line-height: 1vw;
  text-align: center;
}

.current:hover {
  cursor: pointer;
}

.history {
  box-sizing: content-box;
  color: #abafbb;
  border: 0.1vw solid #0c3a54;
  font-size: 0.6vw;
  height: 1vw;
  width: 3vw;
  line-height: 1vw;
  text-align: center;
}

.history:hover {
  cursor: pointer;
}

.active {
  background-color: rgba(2, 181, 219, 0.05);
  color: #02b5db;
  border: 0.1vw solid #02b5db;
}
</style>
